// extracted by mini-css-extract-plugin
module.exports = {"error":"QuestionComponent_error__2FNem"};